
const matchVacancyFieldWithTitle = (field: string): string => {
  const fieldTitleMap: Record<string, string> = {
    vacancyName: 'vacancy title',
    workingConditions: 'working conditions title',
    salary: 'salary',
    interviewStages: 'interview stages',
    additionalInformation: 'additional information',
    checklistLink: 'Check-list link',
    country: 'country',
    city: 'city',
    category: 'category',
    subcategory: 'subcategory',
    currency: 'currency',
    publicationPeriod: 'publication period',
    checklist: 'checklist',
    tags: 'tags',
    duties: 'duties',
    description: 'description',
    presentation: 'presentation',
    visibleFor: 'visible for managers list',
    visibleForRecruiters: 'visible for recruiters list',
    showGdprLink: 'gdpr',
  };


  return fieldTitleMap[field] || field;
}

export default matchVacancyFieldWithTitle;

